import PropTypes from 'prop-types'
import Cookies from 'js-cookie'

import { Header } from '../Header'
import { Footer } from '../Footer'
import * as S from './styled'

const AppLayout = ({ children }) => {
  const isOnMobileApp = Cookies.get('is_on_mobile_app') || false

  return (
    <S.Layout>
      {!isOnMobileApp && <Header />}
      {children}
      {!isOnMobileApp && <Footer />}
    </S.Layout>
  )
}

AppLayout.propTypes = {
  children: PropTypes.node
}

export default AppLayout
